module.exports = __webpack_public_path__ + "static/media/maintain-vehicle.273c47b4.svg";